<template>
  <div class="fiche_medicale">
    <div id="head-page" class="books parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/livres-02.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class="" src="@/assets/images/head/livres.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/papillon.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-8 cell head-page">
          <title-page attrpage="Bibliothèque" baseline="" class-title="tiny"></title-page>
          <bouton href="fiches_medicales" class-bt="return">Retour à la liste</bouton>
        </div>

        <div class="small-12 medium-12 large-8 cell content-page page-fiche-medicale">

          <title-fiche type-item="">La leucémie, qu’est ce que c’est ?</title-fiche>

          <p>Un cancer est une prolifération anormale et incontrôlée de cellules et, dans la leucémie, les cellules touchées sont les cellules sanguines. Ces dernières sont créées à partir de cellules dites souches dans la moelle osseuse, appelé le siège de la production hématopoïétique</p>
          <p>A partir d’une cellule souche, tous les types de cellules sanguines peuvent être fabriqués : les globules rouges, les globules blancs, les plaquettes… C’est ce qu’on appelle la différentiation. Dans la leucémie, la fabrication de ces cellules va être empêchée et les cellules ne pourront pas arriver à maturité pour assurer leur fonction.  Ceci va provoquer une accumulation de cellules immatures dans la moelle osseuse. En fonction du type cellulaire touché, les leucémies seront différentes et leur impact sera également différent.</p>
          <p>De plus, en fonction du stade de la différentiation où la cellule est bloquée, nous allons avoir 2 types de leucémies :</p>
          <p>
            <ul>
              <li> Les leucémies chroniques : les cellules sont bloquées à un stade avancé de la différentiation et l’évolution clinique est lente.</li>
              <li>Les leucémies aigues : les cellules sont bloquées à un stade précoce de la différentiation (elles sont nommées blastes) et l’évolution clinique est rapide.</li>
            </ul>
         </p>

          <p>Il existe ainsi 4 types de leucémies :</p>
          <img class="cover" src="@/assets/images/content/graphique-leucemies.jpg" alt=" 4 types de leucémies" title=" 4 types de leucémies"/>

          </br>
          <bandeau-image lien="#braun" :image-path="require('@/assets/images/content/logo-fle.jpg')">
            <strong>La Fédération Leucémie Espoir proche de vous</strong></br>
            La Fédération Leucémie Espoir regroupe des associations partout en France, venez découvrir la plus proche de chez vous.</br>
            <a href="http://www.leucemie-espoir.org/associations-membres.php" title="carte de France des asso et antennes" alt="carte de rance des asso et antennes">Voir la carte de rance des asso et antennes</a>
          </bandeau-image>

        </div>

        <div class="small-12 medium-12 large-4 cell">
          <div class="head-page"><h2>Ressources Connexes</h2></div>
          <item-fiche lien="#"  titlebox="Leucémie Espoir se développe en Sarthe" type-item="article">La Fédération Leucémie Espoir regroupe des associations et des antennes départementales. Elle s'est fixée 4 missions...</item-fiche>
          <item-fiche lien="#"  titlebox="La leucémie, qu’est ce que c’est ?" type-item="fiche">La leucémie est un cancer des tissus responsables de la formation du sang, c’est-à-dire des cellules sanguines...</item-fiche>
          <item-fiche lien="#"  titlebox="Quels sont les symptômes de la leucémie ?" type-item="video">Il y a les leucémies aiguës et les leucémies chroniques. Dans les leucémies aiguës, comme il y a une baisse...</item-fiche>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Bouton from '@/components/Bouton'
  import ItemFiche from '@/components/ItemFiche'
  import StepInfos from '@/components/StepInfos'
  import BandeauImage from '@/components/BandeauImage'
  import TitlePage from '@/components/TitlePage'
  import TitleFiche from '@/components/TitleFiche'
  export default {
    components: { Bouton, BandeauImage, ItemFiche, TitlePage, TitleFiche, StepInfos },
    computed: {
      currentUser() {
        return this.$store.state.me
      }
    },
    mounted () {
      if (this.currentUser && this.currentUser.account_type === 'child') {
        this.$store.dispatch('seenLibrary')
      }

    }
  }
</script>
